export function createCartOffersStore() {
    return {
        namespaced: true,

        state: {
            /**
             * @type {Offer[]}
             */
            manualOrderOffers: [],

            /**
             * @type {Offer[]}
             */
            couponCodeOffers: [],

            /**
             * The keys are offerIDs.
             *
             * @type {Object<number, number>}
             */
            selectedManualOrderOffers: {},

            /**
             * The keys are offerIDs.
             * (Note: we are only supporting a single selected coupon offer at the moment)
             *
             * @type {Object<number, number>}
             */
            selectedCouponCodeOffers: {},

            /**
             * The keys are offerIDs.
             * The values are the selected corresponding offer codes.
             * (Note: we are only supporting a single selected coupon offer at the moment)
             *
             * @type {Object<number, string>}
             */
            selectedCouponCodeOfferCodes: {},

            /**
             * Count of all coupons in db.
             *
             * @type {number|null}
             */
            couponsCount: null,

            /**
             * Count of all manual cart order offers in db.
             *
             * @type {number|null}
             */
            manualOrderOffersCount: null,
        },

        mutations: {
            setCouponCodeOffers(state, value) {
                state.couponCodeOffers = value;
            },

            setManualOrderOffers(state, value) {
                state.manualOrderOffers = value;
            },

            setSelectedManualOrderOffers(state, value) {
                state.selectedManualOrderOffers = value;
            },

            setSelectedCouponCodeOffers(state, value) {
                state.selectedCouponCodeOffers = value;
            },

            setSelectedCouponCodeOfferCodes(state, value) {
                state.selectedCouponCodeOfferCodes = value;
            },

            setCouponsCount(state, value) {
                state.couponsCount = value;
            },

            setManualOrderOffersCount(state, value) {
                state.manualOrderOffersCount = value;
            },
        },

        getters: {
            /**
             * @param state
             *
             * @return {Object<number, number>}
             */
            selectedOffers(state) {
                return { ...state.selectedManualOrderOffers, ...state.selectedCouponCodeOffers };
            },

            /**
             * @param state
             *
             * @return {Object<number, string>}
             */
            selectedOfferCodes(state) {
                return { ...state.selectedCouponCodeOfferCodes };
            },
        },
    };
}
